import { Component } from '@angular/core';
import globalVariable from "../globalVariable/globalVariable.json"

@Component({
    selector: 'app-footer',
    templateUrl:'./app.footer.component.html'
})
export class AppFooterComponent {
    mobileNumber: any;
    emailAddress: any;
    lang = "en";

    en = {
        "poweredByLabel": "Powered By",
        "phone:Label": "Phone:",
        "email:Label": "Email:",
        "knowAboutTecGymLabel":"Know more about TecGym.",
    }
    ar = {
        "poweredByLabel": "مشغل بواسطة",
        "phone:Label": "هاتف:",
        "Email:Label": "بريد إلكتروني:",
        "knowAboutTecGymLabel":"اعرف المزيد عن TecGym.",

    }
    setLabel(label) {
        if (this.lang === "en") {
            return this.en[label];

        }
        else if (this.lang === "ar") {
            return this.ar[label];

        }

    }
    constructor() { }

    ngOnInit(){
        this.mobileNumber = globalVariable.suportInfo.mobile;
        this.emailAddress = globalVariable.suportInfo.email;
    }
}
